<template>
    <div>
        <slot name="garuda:content"></slot>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    export default {
        watch: {
            $route: {
                immediate: true,
                async handler(to, from) {
                    // this.getToken()
                }
            },
        },
        computed: {
            ...mapGetters({
                garudaToken: 'GarudaController/garudaToken',
            }),
        },
        methods: {
            getToken() {
                if(!this.garudaToken) {
                    this.$store.dispatch( 'GarudaController/getGarudaToken')
                }
            }
        }
    }
</script>
